export default function ServicesProcess() {
  const steps = [
    { step: '01', title: 'Browse Listings', desc: 'View available furnished rooms on our rentals portal and choose the property that suits your needs and location.' },
    { step: '02', title: 'Enquire & Inspect', desc: 'Contact us to arrange an inspection. See the room, meet the team, and get all your questions answered.' },
    { step: '03', title: 'Sign & Move In', desc: 'Complete your tenancy agreement, pay your first week\'s rent and bond, then move in immediately.' },
    { step: '04', title: 'Enjoy Hassle-Free Living', desc: 'Relax and settle in. Everything is already set up — utilities, Wi-Fi, furniture, and cleaning are all sorted.' },
  ];

  return (
    <section className="py-24" style={{ background: 'rgb(246, 248, 252)' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-0.5 bg-gold-500" />
            <span className="text-gold-500 text-sm font-medium tracking-widest uppercase">How It Works</span>
            <div className="w-8 h-0.5 bg-gold-500" />
          </div>
          <h2 className="font-heading text-4xl font-bold text-navy-800 leading-tight">
            Moving In Is Simple
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, idx) => (
            <div key={s.step} className="relative bg-white rounded-lg p-7 border border-navy-100">
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 -right-3 z-10 w-6 h-6 flex items-center justify-center text-gold-400">
                  <i className="ri-arrow-right-line text-lg" />
                </div>
              )}
              <p className="font-heading text-4xl font-bold text-gold-400/40 mb-4">{s.step}</p>
              <h3 className="font-semibold text-navy-800 text-base mb-2">{s.title}</h3>
              <p className="text-navy-700/60 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
